import { productCategory, product } from '../../types';

interface InitialState {
  categories: Array<productCategory>;
  products: Array<product>;
  filteredProducts: Array<product>;
  noFilteredProducts: boolean;
}
const UpdateProductCategoryAction = 'ProductCategory';

export default InitialState;
export { UpdateProductCategoryAction };
